<placeme-layout-seo [seo]="'offersPage.seo' | translate">
  <placeme-jumbotron [seo]="'offersPage.seo' | translate"></placeme-jumbotron>
  <section class="main-content" [class.loading]="isLoading">
    <markdown class="page-markdown" [data]="'offersPage.content' | translate"></markdown>
    <div class="preview">
      <placeme-offer-group-card [offerGroup]="group" class="preview__offer" *ngFor="let group of offerGroups; index as i">
        <a placeme-button [routerLink]="['.'] | localize" fragment="{{ i }}">
          {{ 'offersPage.groups.ctaLabel' | translate }}
        </a>
      </placeme-offer-group-card>
    </div>

    <div [id]="i" class="container__offer" *ngFor="let group of offerGroups; index as i">
      <h3 #revealBackElementRef class="container__offer__title display" [class.container__offer__title--mirror]="i % 2 !== 0">
        {{ group?.seo?.title }}
      </h3>
      <swiper-container
        class="dark"
        pagination="true"
        preventClicks="false"
        slidesPerView="1"
        spaceBetween="50"
        [navigation]="showNavigation"
        pagination="true"
        pagination-clickable="true"
      >
        <swiper-slide *ngFor="let item of group?.offers">
          <placeme-offer-card [offer]="item" [order]="i"></placeme-offer-card>
        </swiper-slide>
      </swiper-container>
    </div>
  </section>
</placeme-layout-seo>
